import { render, staticRenderFns } from "./embed_badge.vue?vue&type=template&id=5c716730&scoped=true&"
import script from "./embed_badge.vue?vue&type=script&lang=js&"
export * from "./embed_badge.vue?vue&type=script&lang=js&"
import style0 from "./embed_badge.vue?vue&type=style&index=0&id=5c716730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c716730",
  null
  
)

export default component.exports